import React from 'react'

const Jva_arrRev = () => {
    return (
        <div className='container'>
            <h1>Program to print the elements of an array in reverse order.</h1>
            <p>Given a number <strong>N</strong>, the task is to print the numbers from <strong>N to 1</strong>.<br/>
            <strong>Examples:</strong>&nbsp;</p>
            <blockquote><p><strong>Input:</strong> N = 1 2 3 4 5 6 7 8 9 10&nbsp;<br/>
            <strong>Output:</strong> 10 9 8 7 6 5 4 3 2 1<br/>
            <strong>Input:</strong> N =  1 2 3 4 5 6 7 &nbsp;<br/>
            <strong>Output:</strong> 7 6 5 4 3 2 1&nbsp; &nbsp;</p></blockquote>
            <h3 class="h2">Algorithm</h3>
            <ol class="points">
<li>Declare and initialize an array.</li>
<li>Loop through the array in reverse order that is, the loop will start from (length of the array - 1) and end at 0 by decreasing the value of i by 1.</li>
<li>Print the element arr[i] in each iteration.</li>
</ol>

<ul className='containers' start="1" class="dp-j">
  <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
        class="keywords">class</span><span>&nbsp;ReverseArray&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
        class="keywords">static</span><span>&nbsp;</span><span
        class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
  </li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="comment">//Initialize&nbsp;array&nbsp;</span><span>&nbsp;&nbsp;</span></span></li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="keywords">int</span><span>&nbsp;[]&nbsp;arr&nbsp;=&nbsp;</span><span
        class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>&nbsp;[]&nbsp;&#123;</span><span
        class="plain">1</span><span>,&nbsp;</span><span class="plain">2</span><span>,&nbsp;</span><span
        class="plain">3</span><span>,&nbsp;</span><span class="plain">4</span><span>,&nbsp;</span><span
        class="plain">5</span><span>&#125;;&nbsp;&nbsp;&nbsp;</span></span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
        class="string">"Original&nbsp;array:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="keywords">for</span><span>&nbsp;(</span><span
        class="keywords">int</span><span>&nbsp;i&nbsp;=&nbsp;</span><span
        class="plain">0</span><span>;&nbsp;i&nbsp;&lt;&nbsp;arr.length;&nbsp;i++)&nbsp;&#123;&nbsp;&nbsp;&nbsp;</span></span>
  </li>
  <li class="alt">
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(arr[i]&nbsp;+&nbsp;<span
        class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;&nbsp;</span></span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println();&nbsp;&nbsp;</span></li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
        class="string">"Array&nbsp;in&nbsp;reverse&nbsp;order:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="comment">//Loop&nbsp;through&nbsp;the&nbsp;array&nbsp;in&nbsp;reverse&nbsp;order</span><span>&nbsp;&nbsp;</span></span>
  </li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="keywords">for</span><span>&nbsp;(</span><span
        class="keywords">int</span><span>&nbsp;i&nbsp;=&nbsp;arr.length-</span><span
        class="plain">1</span><span>;&nbsp;i&nbsp;&gt;=&nbsp;</span><span
        class="plain">0</span><span>;&nbsp;i--)&nbsp;&#123;&nbsp;&nbsp;&nbsp;</span></span></li>
  <li class="alt">
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(arr[i]&nbsp;+&nbsp;<span
        class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;&nbsp;</span></span></li>
  <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
  <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
</ul>
<p><strong>Output:</strong></p>
<div class="output"><pre>Original array:  <br />
1 2 3 4 5  <br />
Array in reverse order:  <br />
5 4 3 2 1  <br />
</pre></div>
        </div>
    )
}

export default Jva_arrRev
